import { render } from "./IconHatchingChick.vue?vue&type=template&id=ece7f706"
const script = {}

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__